import {useForm} from 'react-hook-form'
import React, {useContext, useEffect, useState} from 'react'
import WeaponGroupItemForm from "./item"
import {
    createWeaponGroup,
    getWeaponGroupById,
    updateWeaponGroup
} from '../../../services/components/weaponGroups'
import {Link, useParams} from "react-router-dom";
import Select from "react-select";
import {MainContext} from "../../../context/MainContext";

type WeaponGroupForm = {
    id?: number
    name: string
    size: 'C' | 'L'
    soul: 'L' | 'R'
    restricted: boolean
}

const weaponSizeOptins = [
    {label: 'Curta', value: 'C'},
    {label: 'Longa', value: 'L'}
]
const soul_optins = [
    {label: 'Raiada', value: 'R'},
    {label: 'Lisa', value: 'L'}
]

const restricted_optins = [
    {label: 'Não', value: false},
    {label: 'Sim', value: true}
]

export default function WeaponGroupForm() {
    const {register, handleSubmit, reset, setValue, watch} = useForm<WeaponGroupForm>()
    const [success, setSuccess] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)

    const {setPageTitle, setLoading} = useContext(MainContext)

    let {weaponGroupId } = useParams()

    useEffect(() => {
        setPageTitle("Cadastro de Grupos de Armas")
        setLoading(true)

        const fetchData = async () => {
            if (weaponGroupId == undefined) {
                return
            }

            const {id, name, size, soul, restricted} = await getWeaponGroupById(weaponGroupId)

            setValue('id', id)
            setValue('name', name)
            setValue('size', size)
            setValue('soul', soul)
            setValue('restricted', restricted)
        };

        fetchData().then(setLoading(false))
    }, [])

    const onSubmit = async (data: WeaponGroupForm) => {
        try {
            if (data.id) {
                await updateWeaponGroup(data.id, data)
                setSuccess('Grupo atualizado com sucesso!')
            } else {
                await createWeaponGroup(data)
                setSuccess('Grupo criado com sucesso!')
                reset()
            }
            setError(null)
        } catch (e) {
            setError('Erro ao salvar grupo')
            setSuccess(null)
        }
    }

    return (
        <div className="col-lg-12">
            <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
                <div className="card">
                    <div className="card-body">
                        <div className="row g-3 mt-2">

                            {success && <div className="text-green-600">{success}</div>}
                            {error && <div className="text-red-600">{error}</div>}

                            <input type="hidden" {...register('id')} />

                            <div className="col-md-4">
                                <label htmlFor="name" className="form-label">Nome do grupo<i
                                    className="text-danger"> *</i></label>
                                <input type="text" className="form-control" id="name"
                                       placeholder="Nome do grupo"
                                       {...register('name', {required: true})}/>
                            </div>

                            <div className="col-md-2">
                                <label htmlFor="restricted" className="form-label">Restrito?<i
                                    className="text-danger"> *</i></label>
                                <Select
                                    options={restricted_optins}
                                    value={restricted_optins.find(option => option.value === watch('restricted'))}
                                    onChange={option => setValue('restricted', option?.value as boolean)}
                                    placeholder="Selecione se é restrito"
                                    id="restricted"
                                    name="restricted"
                                />
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="weapon_size" className="form-label">Tamanho de cano<i
                                    className="text-danger"> *</i></label>
                                <Select
                                    options={weaponSizeOptins}
                                    defaultValue={null}
                                    value={weaponSizeOptins.find(option => option.value === watch('size'))}
                                    onChange={option => setValue('size', option?.value as 'C' | 'L')}
                                    placeholder="Selecione o tamanho de cano da arma"
                                    id="weapon_size"
                                    name="weapon_size"
                                />
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="soul" className="form-label">Alma<i
                                    className="text-danger"> *</i></label>
                                <Select
                                    options={soul_optins}
                                    defaultValue={null}
                                    value={soul_optins.find(option => option.value === watch('size'))}
                                    onChange={option => setValue('soul', option?.value as 'R' | 'L')}
                                    placeholder="Selecione a alma de cano"
                                    id="soul"
                                    name="soul"
                                />
                            </div>

                            <div>
                                <button type="submit" className="btn btn-success me-2">Salvar </button>
                                <Link to={"/weapons"} className="btn btn-danger">Cancelar</Link>
                            </div>

                        </div>
                    </div>
                </div>
            </form>

            {weaponGroupId && <WeaponGroupItemForm itemToEdit={weaponGroupId}/>}

        </div>
    )
}
